export default "__VITE_ASSET__b06727a8__"